module.exports = __webpack_public_path__ + "static/media/32.41227a62.mp3";